import React from "react";
import { useSelector } from "react-redux";
import MainLayout from "Layout/MainLayout";
import { getTokenFromReducer } from "Store/reducers/Auth/AuthSlice";

const ConditionalLayout = ({ children }) => {
  const token = useSelector(getTokenFromReducer);

  if (token) {
    return <MainLayout>{children}</MainLayout>;
  }

  return <>{children}</>;
};

export default ConditionalLayout;
